import type { RouteLocationNormalized } from 'vue-router'
import { i18n } from '@/i18n'
import { tenantBrandingString } from '@/services/api/tenant-branding'
import { useTenantBrandingStore } from '@/stores/tenant-branding'

export interface BreadcrumbMetaItem {
  labelKey: string
  path?: string
}

/**
 * Sets document.title from route meta (titleKey or last breadcrumb) plus tenant / app suffix.
 */
export function syncDocumentTitle(to: RouteLocationNormalized): void {
  const titleKey = to.meta.titleKey as string | undefined
  const breadcrumbs = to.meta.breadcrumbs as BreadcrumbMetaItem[] | undefined

  let page = ''
  if (titleKey) {
    page = String(i18n.global.t(titleKey))
  } else if (breadcrumbs?.length) {
    page = String(i18n.global.t(breadcrumbs[breadcrumbs.length - 1].labelKey))
  }

  const brand = useTenantBrandingStore()
  const b = brand.branding
  const suffix =
    `${tenantBrandingString(b, 'shopName') || tenantBrandingString(b, 'appDisplayName')}`.trim() ||
    String(i18n.global.t('app.name'))

  document.title = page ? `${page} · ${suffix}` : suffix
}
